
import DateService from '@/helpers/DateService'
import store from '@/store'

// import DateService from '@/helpers/DateService'

export const orderByCollator = (listadoGuardias) => {
  const collator = new Intl.Collator('es', { sensitivity: 'base' })
  return listadoGuardias.sort((a, b) => collator.compare(a.MEDIO, b.MEDIO))
}

export const createMedioPersonalObject = (match, personal, turnos, fechaSelected, date) => {
  let result
  if (match) {
    result = {
      ID_MEDIO_PERSONAL: match.ID_MEDIO_PERSONAL,
      ID_PERSONAL: match.ID_PERSONAL,
      ID_MEDIO: match.ID_MEDIO,
      FECHA: match.FECHA,
      FECHA_ENTRADA: match.FECHA_ENTRADA,
      FECHA_SALIDA: match.FECHA_SALIDA,
      ID_TURNO: match.ID_TURNO,
      FECHA_HORA_ENTRADA_SALIDA: this.getHoraEntradaSalidaFromDB(match, date),
      state: 'update'
    }
  } else {
    if (personal.MEDIO) {
      result = {
        ID_PERSONAL: personal.MEDIO.GUARDIAS_DINAMICAS ? null : personal.ID_PERSONAL,
        ID_MEDIO: personal.MEDIO.ID_MEDIO
      }
    } else {
      result = {
        ID_PERSONAL: personal.PERSONAL ? personal.PERSONAL.ID_PERSONAL : null,
        ID_MEDIO: null // Los personales asociados a un personal permanentemente tendran un ID_MEDIO aquí, si no, vendrá a null.
      }
    }
    result.FECHA = null
    result.ID_TURNO = turnos.length === 1 ? turnos[0].ID_TURNO : null
    result.FECHA_HORA_ENTRADA_SALIDA = turnos.length === 1 ? getHoraEntradaSalidaFromTurno(this.turnos[0].ID_TURNO, turnos, fechaSelected) : ''
    result.state = 'insert'
  }
  return result
}

const getHoraEntradaSalidaFromTurno = (ID_TURNO, turnos, fechaSelected) => {
  const t = Array.isArray(turnos) ? turnos.find((x) => x.ID_TURNO === ID_TURNO) : undefined
  return t ? `${fechaSelected} ${t.HORA_ENTRADA} - ${t.HORA_SALIDA}` : ''
}

export const getNombrePersonalGuardia = (recursoSector) => {
  if (!recursoSector?.RECURSO_SECTOR_ESTADO?.length && !recursoSector?.MEDIO) return ''
  const medio = recursoSector?.RECURSO?.MEDIO || recursoSector?.MEDIO
  if (!medio) return ''

  // ordenamos los estados por fecha
  const idMedio = medio.ID_MEDIO
  const fechaAsignado = [...recursoSector.RECURSO_SECTOR_ESTADO]
    .sort((a, b) => DateService.toDayjs(a.FECHA) - DateService.toDayjs(b.FECHA))[0]?.FECHA

  const personalAsignado = store.getters['medioPersonal/getPersonalAsignado'](idMedio, fechaAsignado)

  const recursoAsignado = store.getters['recurso/getPersonalById'](personalAsignado?.ID_PERSONAL)
  const recursoNombre = store.getters['recurso/getRecursoNameById'](recursoAsignado?.ID_RECURSO)

  return personalAsignado ? ` ${recursoNombre}` : ''
}
